export default __webpack_public_path__ + "static/media/driverIcon.5dc2a2a4.png";